import { useState } from "react";
import ImageBoxFreeContent from "./ImageBoxFreeContent/ImageBoxFreeContent";
import BoxDescription from "./BoxDescription/BoxDescription";

function BoxFreeContent({ item }) {
    const [display, setDisplay] = useState(false)

    return (
        <div className="flex flex-row-reverse bg-white rounded-lg shadow p-2 w-2/4 mb-4">
            <img src="/image/image.jpg" className="w-2/6 ml-5 rounded object-cover" />
            <div className="flex flex-col items-end justify-between w-4/6 text-right">
                <div className="flex flex-row-reverse items-center justify-between w-full">
                    <ImageBoxFreeContent item={item.socialNetwork} />
                    <div className="flex flex-row items-center">
                        <img src="/image/icon/delete.png" className="w-6" />
                        <img src="/image/icon/edit.png" className="w-7" />
                    </div>
                </div>
                <p className="font-bold mb-1 mr-1">{item.title}</p>
                <a className="text-blue-500 text-xs mb-2">{item.link}</a>
                <BoxDescription item={item} display={display} setDisplay={setDisplay} />
            </div>
        </div>
    )
}
export default BoxFreeContent;